module.exports = [
    "upload your images",
    "validate your images",
    "apply preprocessing",
    "generate prediction",
    "sending you back the results"
]